export enum Rwd {
  screenXxxl = <any>'screenXxxl',
  screenXxl = <any>'screenXxl',
  screenXl = <any>'screenXl',
  screenLg = <any>'screenLg',
  screenMd = <any>'screenMd',
  screenSm = <any>'screenSm',
  screenXs = <any>'screenXs'
}
